import script from "./FetchUserMixins.vue?vue&type=script&lang=js"
export * from "./FetchUserMixins.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__